import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap"


// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// users
import user1 from "../../../assets/images/users/avatar-1.jpg"

const ProfileMenu = props => {
    // Declare a new state variable, which we'll call "menu"
    const [menu, setMenu] = useState(false)

    const [username, setusername] = useState("Admin")

    useEffect(() => {
        if (localStorage.getItem("authUser")) {
            if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
                const obj = JSON.parse(localStorage.getItem("authUser"))
                setusername(obj.displayName)
            } else if (
                process.env.REACT_APP_DEFAULTAUTH === "fake" ||
                process.env.REACT_APP_DEFAULTAUTH === "jwt"
            ) {
                const obj = JSON.parse(localStorage.getItem("authUser"))
                setusername(obj.username)
            }
        }
    }, [props.success, props.userProfileInfo])

    return (
        <React.Fragment>
            <Dropdown
                isOpen={menu}
                toggle={() => setMenu(!menu)}
                className="d-inline-block"
            >
                <DropdownToggle
                    className="btn header-item "
                    id="page-header-user-dropdown"
                    tag="button"
                >
                    {props.userProfileInfo?.photo ? (
                        <img
                            className="rounded-circle header-profile-user"
                            src={props.userProfileInfo?.photo}
                            alt="Header Avatar"
                        />
                    ) : (<div className="rounded-circle header-profile-user d-flex align-items-center justify-content-center fw-bold ">{props.userProfileInfo?.displayName?.[0] || ""}</div>)}

                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem tag="a" href="/profile">
                        {" "}
                        <i className="bx bx-user font-size-16 align-middle me-1" />
                        {"Profile"}{" "}
                    </DropdownItem>
                    {/* <DropdownItem tag="a" href="/crypto-wallet">
            <i className="bx bx-wallet font-size-16 align-middle me-1" />
            {props.t("My Wallet")}
          </DropdownItem> */}
                    {/* <DropdownItem tag="a" href="/reset-password">
            <i className="bx bx-wallet font-size-16 align-middle me-1" />
            {props.t("Reset Password")}
          </DropdownItem> */}
                    {/* <DropdownItem tag="a" href="#">
            <span className="badge bg-success float-end">11</span>
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            {props.t("Settings")}
          </DropdownItem>
          <DropdownItem tag="a" href="auth-lock-screen">
            <i className="bx bx-lock-open font-size-16 align-middle me-1" />
            {props.t("Lock screen")}
          </DropdownItem> */}
                    <div className="dropdown-divider" />
                    <Link to="/logout" className="dropdown-item">
                        <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
                        <span>{"Logout"}</span>
                    </Link>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    )
}

ProfileMenu.propTypes = {
    success: PropTypes.any,
    t: PropTypes.any,
    userProfileInfo: PropTypes.object,
}

const mapStatetoProps = state => {
    const { error, success, userProfileInfo } = state.Profile
    return { error, success, userProfileInfo }
}

export default withRouter(
    connect(mapStatetoProps, {})((ProfileMenu))
)
